module.exports = __webpack_public_path__ + "img/rrr_rorgametoken.8e55555.png";